module.exports = __webpack_public_path__ + "static/img/unionpay.64833375.png";